import { render, staticRenderFns } from "./VineyardSimplePowerMetricTable.vue?vue&type=template&id=f434c5d4&scoped=true&"
import script from "./VineyardSimplePowerMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardSimplePowerMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f434c5d4",
  null
  
)

export default component.exports